import React from "react";
import { Text2xl, TextLg, TextMd, TextSm } from "../../../components/text";

export const AboutMe = ({ className = "", style = {} }) => {
  return (
    <section
      className={`flex flex-col gap-6 ${className}`}
      style={style}
    >
      <TextMd className="uppercase tracking-[0.1em] text-gray-500 font-semibold px-6 mx-auto select-none">
        About Me
      </TextMd>

      <div className="flex flex-col md:flex-row items-center gap-9 mx-auto">
        <div className="rounded-full min-w-[120px] max-w-[260px] w-1/5 md:w-1/4 h-fit aspect-square overflow-hidden shadow-lg grid place-items-center select-none">
          <img
            src="/images/colt-holt.png"
            className="pointer-events-none"
          />
        </div>

        <div className="flex flex-col items-center md:items-start">

          <div className="flex flex-col md:flex-row gap-x-6 items-center md:items-start">
            <TextLg className="font-semibold text-gray-900">
              Colt Holt
            </TextLg>

            <div className="flex flex-wrap items-center gap-3 text-gray-500 font-medium my-auto">
              <TextMd>Data Analyst</TextMd>

              <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />

              <TextMd>Web Developer</TextMd>
            </div>
          </div>
          
          <TextMd className="mt-3 text-gray-800 leading-relaxed font-medium text-center px-2">
            Turning data into insights, and ideas into software.
          </TextMd>

          <TextSm className="flex mt-2 text-gray-600 leading-7 text-center relative px-2 md:text-start flex-col font-medium">
            <span className="w-fit">
              I help businesses unlock the value of their data and digital
              processes through analytics, automation, and interactive dashboards.
            </span>
            <span className="w-fit">
              Combining data analysis with modern web
              development, I build solutions that improve efficiency,
              support decision-making, and create a better user experience.
            </span>
          </TextSm>
        </div>
      </div>
    </section>
  );
};